import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import {SENTRY_DSN} from './config/env'
import App from './App'
import TelegramLanding from './components/pages/TelegramLanding'
import BlogListPage from './components/pages/BlogListPage'
import BlogArticlePage from './components/pages/BlogArticlePage'
import NotFoundPage from './components/pages/NotFoundPage'
import InstallAppButton from './components/InstallAppButton'
import {parseRoute} from './utils/routeParser'
import {getBlogArticleBySlug} from './config/blogArticles'
import './index.css'

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
}

if (import.meta.env.PROD) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
            Sentry.replayIntegration()
        ],
        replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
}

// Path-based routing
function Router() {
    const path = window.location.pathname;
    const route = parseRoute(path);

    // Telegram landing
    if (route.type === 'telegram') {
        return <TelegramLanding/>;
    }

    // Blog
    if (route.type === 'blog') {
        return <BlogListPage/>;
    }
    if (route.type === 'blogArticle') {
        if (!getBlogArticleBySlug(route.slug)) {
            return <NotFoundPage/>;
        }
        return <BlogArticlePage slug={route.slug}/>;
    }

    // Music page
    if (route.type === 'music') {
        return <App initialView="music"/>;
    }

    // Skazki (fairy tales)
    if (route.type === 'skazki') {
        return <App initialView="skazki"/>;
    }
    if (route.type === 'skazkiNew') {
        return <App initialView="skazki" skazkiAction="new"/>;
    }
    if (route.type === 'skazkiTale') {
        return <App initialView="skazki" skazkiTaleId={route.taleId}/>;
    }

    // Home or HR pages
    if (route.type === 'home' || route.type === 'hr') {
        return <App/>;
    }

    // 404 page
    return <NotFoundPage/>;
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={
            <div style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif', padding: '20px', textAlign: 'center'}}>
                <div>
                    <p style={{fontSize: '18px', color: '#333', marginBottom: '16px'}}>Что-то пошло не так. Попробуйте обновить страницу.</p>
                    <button onClick={() => window.location.reload()} style={{padding: '12px 24px', background: 'linear-gradient(to right, #e53e3e, #ed64a6, #ed8936)', color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', cursor: 'pointer'}}>
                        Обновить
                    </button>
                </div>
            </div>
        }>
            <Router/>
            <InstallAppButton/>
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
)
